import { services } from 'services/base';
import {
  GetPreloginWidgetService,
  OnPreloginWidgetChangeService,
  ResetPreloginWidgetService,
  SetPreloginWidgetService,
} from 'types';

type PreloginState = {
  widget: string | null;
};

const SERVICE_PREFIX = 'appFrame.prelogin';
const ACTION_PRELOGIN_CHANGE_WIDGET = 'AppFrame:Prelogin:ChangeWidget';

const initPreloginServices = () => {
  const { registerAction, registerService, executeAction, clearAction } = services;

  const state: PreloginState = {
    widget: null,
  };
  registerAction(
    ACTION_PRELOGIN_CHANGE_WIDGET,
    (widget: string | null) => {
      state.widget = widget;
    },
    { order: 0 },
  );
  registerService<SetPreloginWidgetService>(`${SERVICE_PREFIX}.setWidget`, (widget: string) => {
    executeAction(ACTION_PRELOGIN_CHANGE_WIDGET, widget);
  });

  registerService<GetPreloginWidgetService>(`${SERVICE_PREFIX}.getWidget`, () => state.widget);

  registerService<ResetPreloginWidgetService>(`${SERVICE_PREFIX}.resetWidget`, () => {
    executeAction(ACTION_PRELOGIN_CHANGE_WIDGET, null);
  });

  registerService<OnPreloginWidgetChangeService>(`${SERVICE_PREFIX}.onWidgetChange`, (fn) => {
    registerAction(ACTION_PRELOGIN_CHANGE_WIDGET, fn, { order: 1 });

    return () => clearAction(ACTION_PRELOGIN_CHANGE_WIDGET, fn);
  });
};

export default initPreloginServices;
